import * as React from "react";
import { statusLabel, type LeadStatus } from "../lead-status";

export interface ContactAttempt {
  userId: string;
  name: string;
  color: string | null;
  status: LeadStatus; // no_answer | disconnected
  at: string; // ISO
}

function kstShort(iso: string): string {
  const d = new Date(new Date(iso).getTime() + 9 * 3600 * 1000);
  const mm = String(d.getUTCMonth() + 1).padStart(2, "0");
  const dd = String(d.getUTCDate()).padStart(2, "0");
  const hh = String(d.getUTCHours()).padStart(2, "0");
  const mi = String(d.getUTCMinutes()).padStart(2, "0");
  return `${mm}-${dd} ${hh}:${mi}`;
}

const MAX_DOTS = 4;

// 연락 시도(부재/단선) 스택 — 앞쪽 몇 명의 색 점만 보여주고, 나머지는 뒤에 "+N".
// 점에 hover 하면 "이름 · 상태 · 시각". 자세한 내역은 클릭(모달)으로.
// showLastTime 이면 아래에 마지막 시도 시각(좌정렬).
export function ContactAttemptStack({
  attempts,
  showLastTime,
}: {
  attempts: ContactAttempt[];
  showLastTime?: boolean;
}): React.ReactElement | null {
  if (!attempts || attempts.length === 0) return null;
  // 앞에서부터 MAX_DOTS 개만 색 점, 나머지는 뒤쪽 "+N" 배지.
  const visible = attempts.slice(0, MAX_DOTS);
  const rest = attempts.length - visible.length;
  const last = attempts[attempts.length - 1]!;
  return (
    <span className="inline-flex flex-col gap-0.5 items-start align-middle">
      <span className="flex items-center">
        {visible.map((a, i) => (
          <span
            key={i}
            title={`${a.name} · ${statusLabel(a.status)} · ${kstShort(a.at)}`}
            className="w-4 h-4 rounded-full border-2 border-surface -ml-1.5 first:ml-0"
            style={{ backgroundColor: a.color ?? "#9ca3af" }}
          />
        ))}
        {rest > 0 && (
          <span className="ml-1 text-[11px] text-ink-muted tabular-nums">
            +{rest}
          </span>
        )}
      </span>
      {showLastTime && (
        <span className="text-[10px] text-ink-subtle tabular-nums text-left">
          {kstShort(last.at)}
        </span>
      )}
    </span>
  );
}
